

export function getTotalProgress(progressList = [], listWeights = []) {
    if (progressList.length !== listWeights.length) throw new Error('expected equal lengths for progressList and listWeights')
    const filteredWeights = []
    const filteredList = progressList.filter((p, i) => {
        const isDefined = p !== undefined
        if (isDefined) filteredWeights.push(listWeights[i])
        return isDefined
    })

    const weightsSum = filteredWeights.reduce((a, b) => a + b, 0)

    const totalProgress = 100 * (
        filteredList.map((p, i) => (p / 100) * filteredWeights[i]).reduce((a, b) => a + b, 0)
        /
        weightsSum
    )

    return totalProgress
}


export function filterTestCategoriesOfAnalyses(analyses, testCategories) {
    //mutates an array of analyses to drop the testcategories not included in the testCategories array
    if (!Array.isArray(analyses) || !Array.isArray(testCategories)) {
        throw new Error('Could not filter testcategories of analyeses, expected array')
    }
    analyses.forEach(anal => {
        if (!Array.isArray(anal.tests)) return
        anal.tests = anal.tests.filter(test => !test.testCategory?.id ? false :
            testCategories.includes(test.testCategory.id)
        )
    })
}


const convertedEventUnits = {
    // these are the only metrics that need to be converted
    // key | unitSI
    MowingEvent: {
        mowingHeight: 'mm',
        clippingWeights: 'L',  // yes this originally was weight in kg, but we display it as L and should be equivalent
    },
    FertilisingEvent: {
        amount: 'kg',
    },
    SeedingEvent: {
        amount: 'kg',
    },
    IrrigationEvent: {
        zoneResults: {
            millimeters: 'mm',
        }
    },
    GroomingEvent: {
        debrisAmount: 'kg'
    },
    TopDressingEvent: {
        amount: 'kg'
    },
    LineMarkingEvent: {
        amount: 'L'
    },
}

export function handleUnitConvertEvent(event, convertToUnits) {

    if (!convertedEventUnits[event.type]) return

    const zoneResults = convertedEventUnits[event.type].zoneResults
    if (zoneResults) {
        Object.keys(zoneResults).forEach(key => {
            event.zoneResults.forEach(zR => {
                zR[key] = convertToUnits(zR[key], zoneResults[key], { metricPrecision: 0, useSecondaryUnit: false }).primaryValue
            })
        })
    }

    const other = convertedEventUnits[event.type]
    if (other) {
        Object.keys(other).forEach(key => {
            if (key === 'zoneResults') return
            event[key] = convertToUnits(event[key], other[key], { metricPrecision: 0, useSecondaryUnit: false }).primaryValue
        })
    }
}

export function getConvertedEventUnitsTuples(formatUnitName) {
    const metricUnitList = getDeepestValues(convertedEventUnits)
    const setArray = [...new Set(metricUnitList)]
    return setArray.map(unit => [unit, formatUnitName(unit, { useSecondaryUnit: false })])
}

function getDeepestValues(obj) {
    const result = [];

    function traverse(current) {
        if (typeof current !== 'object' || current === null) {
            result.push(current);
            return;
        }

        const keys = Object.keys(current);
        if (keys.length === 0) {
            // Handle empty object
            result.push(current);
        }

        for (let key of keys) {
            traverse(current[key]);
        }
    }

    traverse(obj);
    return result;
}

export const deviceMeasurementTypesToClean = [
    "energy-restitution",
    'hardness',
    "rotational-stiffness",
    "rotational-traction",
    "shock-absorption",
    "spring-rate",
    "stud-depth",
    "surface-deformation",
    "torque-10-deg",
]